<mat-card class="about-view">
    <mat-card-header>
        <mat-card-title>ABOUT US</mat-card-title>
        <mat-card-subtitle>Last updated 9/21/2024</mat-card-subtitle>
    </mat-card-header>

<mat-card-content>
    <h3>About <strong>Price Matcher</strong></h3>
    <p>Welcome to <strong>Price Matcher</strong>! 
    <p>Price Matcher is a price comparison tool designed to help users find the best deals across multiple stores. Our easy-to-use interface and built-in price calculator allow you to quickly compare prices and make informed purchasing decisions.</p>
    <p>We’re currently in beta testing, so feel free to explore and share any feedback! Our goal is to provide a seamless, helpful, and transparent tool to enhance your shopping experience.</p> 

</mat-card-content>
</mat-card>